// extracted by mini-css-extract-plugin
module.exports = {"join":"join_join__3z2C0","title":"join_title__2Czba","room":"join_room__2JJ3F","name":"join_name__2V_Oz","form":"join_form__3GZ1I","inputs":"join_inputs__1FPjt"};